export const ErrorCode = Object.freeze({
  GstInNumberAddressNotMatch: 'GstInNumberAddressNotMatch',
});
